import {useState, useMemo} from 'react'
import {DialogsWrapper} from './components/DialogsWrapper'
import {CreateDialogModal} from './components/CreateDialogModal/CreateDialogModal'
import {WuButton, WuIcon} from '@npm-questionpro/wick-ui-lib'
import {dialogApi} from '../../api/dialogApi'
import {LoadingPage} from '../LoadingPage'
import styles from './Dialogs.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {DIALOG} from '../../Translation/English/dialog'

export const Dialogs = (): React.ReactElement => {
  const wt = useWt()
  const {data: totalDialogsCount = 0, isLoading} = dialogApi.useDialogCount()

  const [showCreateDialogModal, setShowCreateDialogModal] =
    useState<boolean>(false)

  const showWrapper = totalDialogsCount > 0

  const EmptyState = useMemo(
    () => (
      <div className={styles.dialogEmptyState}>
        <div className={styles.dialogEmptyStateTitle}>
          {wt(DIALOG.welcomeToConversations)}
        </div>
        <div className={styles.dialogEmptyStateDesp}>
          {wt(DIALOG.description)}
        </div>
        <div className={'round-button'}>
          <WuButton
            className={styles.dialogEmptyStateBtn}
            data-testid="dialog-new-btn"
            onClick={() => {
              setShowCreateDialogModal(true)
            }}
          >
            <WuIcon icon="wm-add" /> {wt(DIALOG.startNewConversation)}
          </WuButton>
        </div>
        {showCreateDialogModal && (
          <CreateDialogModal
            showModal={showCreateDialogModal}
            closeModal={() => setShowCreateDialogModal(false)}
          />
        )}
      </div>
    ),
    [showCreateDialogModal, wt],
  )

  return (
    <>
      {isLoading && <LoadingPage />}
      {showWrapper ? (
        <div className={styles.dialogs}>
          <DialogsWrapper />
        </div>
      ) : (
        !isLoading && EmptyState
      )}
    </>
  )
}
